import ButtonCloseMenu from "components/button-close";
import useRouter from "hooks/use-router";

interface IProps {
  title?: string;
  handleSubmit: any;
  children: React.ReactNode;
}

export default function StepperComponent({ title, handleSubmit, children }: IProps) {
  const { history } = useRouter()

  return (
    <form className="flex justify-between flex-col items-center h-full w-full" onSubmit={handleSubmit}>
      <ButtonCloseMenu
        open={true}
        paramFn={() => {
          gtag('event', 'Click', {
            event_category: GTM_EVENT_CATEGORY,
            event_label: 'Survey - Cerrar modal',
            value: '10'
          })
          history.goBack();
        }}
      />
      <div className="w-full px-4">
        <img src={`${AZURE_BASE_URL}/survey/img_enzabezado.webp`} className='w-full' />
        {title && <h2 className="text-center mt-5 mb-5 survey-title">{title}</h2>}
        {children}
      </div>
    </form>
  )
}